import { Box, Stack } from "@mui/material";
import { TextBlock } from "./TextBlock";

export const UlList = ({
  text,
  items,
}: {
  text: string[];
  items: string[];
}) => {
  if (!items) return null;
  return (
    <Stack gap="16px">
      <TextBlock text={text} />
      <Stack gap="8px">
        {items.map((el) => (
          <Stack gap="8px" flexDirection="row" alignItems="flex-start" key={el}>
            <Stack alignItems="center" justifyContent="center" height="24px">
              <Box
                style={{
                  minWidth: "6px",
                  width: "6px",
                  height: "6px",
                  borderRadius: "50%",
                  backgroundColor: "#005EAB",
                }}
              />
            </Stack>

            <TextBlock text={[el]} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
